
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  CandidateNewResult,
  ColorDetectionConfig,
  ColorQuestionAnswer
} from "@/lib/model/exam/candidate-result";

@Component({})
export default class MessageDialog extends Vue {
  @Prop({}) all!: CandidateNewResult;
  @Prop({ default: false }) isH5!: boolean;
  @Prop({ default: false }) inReport!: boolean;

  isShowMore = false;

  //色盲题结构
  get getColorTestQuestion(): ColorDetectionConfig {
    return this.all.report.colorDetection || new ColorDetectionConfig();
  }
  //细分类型 变更 不分类型了
  questionListByType(): ColorQuestionAnswer[] {
    if (this.isShowMore) {
      return this.getColorTestQuestion.colorQuestionAnswerList;
    } else {
      return this.getColorTestQuestion.colorQuestionAnswerList.slice(0, 2);
    }
  }
}
